<template>
  <div class="home">

    <LayoutTopComponent></LayoutTopComponent>

    <div class="home_center_one" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'"
                   :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in oneImgList" :key="index">
          <img @click="itemClick(item,index)" class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="home_center_two">
      <div class="home_center_two_container">
        <div class="two_about">
          <div>
            <img src="../assets/images/home_two_about.png">
          </div>
        </div>

        <div class="two_table">

          <div class="two_table_top">
            <div class="two_table_top_left">
              <div class="two_top_left_container">
                <div class="container_top">
                  <div class="container_title">智能化</div>
                  <div class="container_english">INTELLIGENT</div>
                  <div class="container_serial">01</div>
                </div>
                <div class="container_bottom">
                  <div>富从产品，以标准化为基础的设备自动化生产及设备智能化运行。</div>
                </div>
              </div>
            </div>
            <div class="two_table_top_right">
              <div class="two_top_riht_container">
                <div class="container_top">
                  <div class="container_serial">02</div>
                  <div class="container_title">工业级</div>
                  <div class="container_english">INDUSTRIAL-GRADE</div>
                </div>
                <div class="container_bottom">
                  <div>产品整体设计稳重大方，以人机工程学为依据设计操作面板整体布局，操作更加人性化，现代化生产设备。</div>
                </div>
              </div>
            </div>
          </div>
          <div class="two_table_bottom">
            <div class="two_table_bottom_left">
              <div class="two_bottom_left_container">
                <div class="container_top">
                  <div class="container_title">标准化</div>
                  <div class="container_english">STANDARDIZED</div>
                </div>
                <div class="container_center">
                  <div>具备从生产加工、运输、安装、试运行和正常运行最基本的规范，包括技术规范和施工规范。同时也具备成套设备的标准。</div>
                </div>
                <div class="container_bottom">
                  <div>03</div>
                </div>
              </div>
            </div>
            <div class="two_table_bottom_right">
              <div class="two_bottom_right_container">
                <div class="container_top">
                  <div class="container_title">可定制</div>
                  <div class="container_english">CUSTOMIZABLE</div>
                </div>
                <div class="container_center">
                  <div>产品具备根据用户的特定功能需求来重新设计或进行调整修改。</div>
                </div>
                <div class="container_bottom">
                  <div>04</div>
                </div>
              </div>
            </div>
          </div>

          <div class="two_table_center">
            <img src="../assets/images/home_two_table_center.png">
          </div>

        </div>

      </div>
    </div>

    <div class="home_center_three">
      <div class="home_center_three_container">
        <div class="three_about">
          <div>
            <img src="../assets/images/home_three_recommend.png">
          </div>
        </div>
        <div class="three_table">

          <div v-for="(item,index) in twoList" class="three_table_item" @click="itemClick(item,index)" >
            <div class="three_table_item_image">
              <img :src="item.url">
            </div>
            <div class="three_table_item_text">
              <div class="three_table_item_point"></div>
              <div>
                <div>{{ item.name }}</div>
                <div>{{ item.desc }}</div>
              </div>
              <div class="three_table_item_point"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home_center_four">
      <div class="home_center_four_container">
        <div class="four_about">
          <div>
            <img src="../assets/images/home_four_demo.png">
          </div>
        </div>
        <div class="four_table">

          <div v-for="(item,index) in fourList" class="four_table_item" @click="fourItemClick(item,index)">
            <div class="four_table_item_image">
              <img :src="item.url">
            </div>
            <div class="four_table_item_text">
              <div>{{ item.name }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <LayoutBottomComponent></LayoutBottomComponent>

  </div>
</template>

<script>

import LayoutTopComponent from '../components/LayoutTopComponent'
import LayoutBottomComponent from '../components/LayoutBottomComponent'

export default {
  data() {
    return {
      pagesHeight: '',
      oneImgList: [
        {
          url: require("../assets/images/home_view_pager_002.png"),
          type: "CJ9100"
        },
        {
          url: require("../assets/images/home_view_pager_003.png"),
          type: "BL2FL01"
        },
        {
          url: require("../assets/images/home_view_pager_004.png"),
          type: "BLZNC03"
        },
        {
          url: require("../assets/images/home_view_pager_001.png"),
          type: "BL3FL02"
        },
      ],
      twoList: [
        {
          url: require("../assets/images/home_three_001.png"),
          name: "智能回收柜",
          desc: "BLHSG03",
          type:"BLHSG03"
        }, {
          url: require("../assets/images/home_three_002.png"),
          name: "闸机",
          desc: "ZJ4361",
          type:"ZJ4361"
        }, {
          url: require("../assets/images/home_three_003.png"),
          name: "晨检机",
          desc: "CJ9100",
          type:"CJ9100"
        }
      ],
      fourList: [
        {
          url: require("../assets/images/home_four_001.png"),
          name: "学校彩色闸机案例",
          type: "ZJ4362"
        },
        {
          url: require("../assets/images/home_four_002.png"),
          name: "学校不锈钢闸机案例",
          type:"ZJ4361"
        },
        {
          url: require("../assets/images/home_four_003.png"),
          name: "学校电子班牌案例",
          type:"BP4202"
        },
        {
          url: require("../assets/images/home_four_004.png"),
          name: "智能收集秤案例",
          type:"BLZNC03"
        },
        {
          url: require("../assets/images/home_four_005.png"),
          name: "垃圾箱案例",
          type:"BL2FL01"
        },
        {
          url: require("../assets/images/home_four_006.png"),
          name: "积分兑换机案例",
          type:"BLSHJ02"
        },
        {
          url: require("../assets/images/home_four_007.png"),
          name: "垃圾房案例",
          type:"BL3FL02"
        },
        {
          url: require("../assets/images/home_four_008.png"),
          name: "回收柜案例",
          type:"BLHSG03"
        },
      ]
    }
  },
  mounted() {
    this.pagesHeight = this.$refs.pagesRef.clientHeight;
  },
  components: {
    LayoutTopComponent,
    LayoutBottomComponent
  },
  methods: {
    fourItemClick: function (res, index) {
      if (res.type) {
        this.$router.push("/Detail?&type=" + res.type)
      }
    },
    itemClick: function (res, index) {
      if (res.type) {
        this.$router.push("/Detail?&type=" + res.type)
      }
    },
  }


}

</script>


<style lang="less" scoped>

@import "../assets/css/common";

// 设配 代码
@media screen and (max-width: 1280px) {

  .home {
    width: @screenWidth1280;
    margin-top: @layoutTopHight1280;

    .home_center_one {
      height: @viewPager1280;

      .imgCls {
        width: 100%;
        height: @viewPager1280;
      }
    }
  }

  .home_center_three_container {

    .three_table {
      margin: 0 20px 60px;

      .three_table_item {
        margin: 20px;
        height: 360px;
      }

    }

    .three_about {
      margin: 58px 0 42px 0;
    }
  }

  .home_center_four_container {
    .four_table {
      margin: 38px 135px 0;
    }

    .four_about {
      margin: 48px 0 12px 0;
    }

  }
}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .home {
    width: @screenWidth1440;
    margin-top: @layoutTopHight1440;

    .home_center_one {
      height: @viewPager1440;

      .imgCls {
        width: 100%;
        height: @viewPager1440;
      }
    }

  }

  .home_center_three_container {

    .three_table {
      margin: 0 20px 72px 20px;

      .three_table_item {
        margin: 20px;
        height: 390px;
      }
    }

    .three_about {
      margin: 58px 0 58px 0;
    }

  }

  .home_center_four_container {
    .four_table {
      margin: 38px 172px 0;
    }

    .four_about {
      margin: 48px 0 12px 0;
    }

  }
}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .home {
    width: @screenWidth1920;
    margin-top: @layoutTopHight1920;
    // 首页轮播图
    .home_center_one {
      height: @viewPager1920;

      .imgCls {
        width: 100%;
        height: @viewPager1920;
      }
    }
  }

  .home_center_three_container {
    .three_table {
      margin: 0 300px 72px;

      .three_table_item {
        margin: 20px;
        height: 390px;
      }

    }

    .three_about {
      margin: 58px 0 58px 0;
    }
  }

  .home_center_four_container {
    .four_table {
      margin: 38px 300px 0;
    }

    .four_about {
      margin: 60px 0 30px 0;
    }

  }
}

.twoTableItemWH() {
  width: 594px;
  height: 269px;
}


.home {

  display: flex;
  flex-direction: column;

  .home_center_one {
  }

  .home_center_two {
    display: flex;

    .home_center_two_container {
      width: 100%;
      display: flex;
      flex-direction: column;

      .two_about {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 49px 0 60px 0;
      }

      .two_table {

        display: flex;
        flex-direction: column;
        margin: 0 0 74px 0;

        .two_table_top {
          display: flex;
          justify-content: center;
          margin-bottom: 69px;

          .two_table_top_left {
            .twoTableItemWH();
            margin-right: 72.5px;
            background: url("../assets/images/home_two_table_top_left.png");

            .two_top_left_container {
              display: flex;
              flex-direction: column;

              .container_top {
                display: flex;
                justify-content: space-around;
                margin: 0 115px 0 28px;

                .container_title {
                  color: #2A57EA;
                  font-size: 30px;
                  font-family: SourceHanSansCN-Medium;
                  margin: 45px 0 0 0;
                }

                .container_english {
                  color: #aabcf7;
                  font-size: 14px;
                  font-family: Regular;
                  margin: 61px 0 0 0;
                }

                .container_serial {
                  color: #aabcf7;
                  font-size: 82px;
                  font-family: Regular;
                }

              }

              .container_bottom {
                color: #333333;
                font-size: 18px;
                font-family: SourceHanSansCN-Regular;
                margin: 0 224px 0 28px;
                text-align: left;
                line-height: 36px;
              }

            }

          }

          .two_table_top_right {
            .twoTableItemWH();
            margin-left: 72.5px;
            background: url("../assets/images/home_two_table_top_right.png");

            .two_top_riht_container {
              display: flex;
              flex-direction: column;

              .container_top {
                display: flex;
                justify-content: space-around;
                margin: 0 10px 0 91px;

                .container_title {
                  color: #2A57EA;
                  font-size: 30px;
                  font-family: SourceHanSansCN-Medium;
                  margin: 45px 0 0 0;
                }

                .container_english {
                  color: #aabcf7;
                  font-size: 14px;
                  font-family: Regular;
                  margin: 61px 0 0 0;
                }

                .container_serial {
                  color: #aabcf7;
                  font-size: 82px;
                  font-family: Regular;
                }

              }

              .container_bottom {
                color: #333333;
                font-size: 18px;
                font-family: SourceHanSansCN-Regular;
                margin: 0 28px 0 228px;
                text-align: left;
                line-height: 36px;
              }
            }

          }

        }

        .two_table_bottom {
          display: flex;
          justify-content: center;

          .two_table_bottom_left {
            .twoTableItemWH();
            margin-right: 72.5px;
            background: url("../assets/images/home_two_table_bottom_left.png");

            .two_bottom_left_container {
              display: flex;
              flex-direction: column;

              .container_top {
                display: flex;

                .container_title {
                  color: #2A57EA;
                  font-size: 30px;
                  font-family: SourceHanSansCN-Medium;
                  margin: 45px 0 0 28px;
                }

                .container_english {
                  //color: #aabcf7;
                  opacity: 0.4;
                  color: #2A57EA;
                  font-size: 14px;
                  font-family: Regular;
                  margin: 63px 0 0 45px;
                }
              }

              .container_center {
                color: #333333;
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                margin: 42px 228px 0 28px;
                text-align: left;
                line-height: 36px;
              }

              .container_bottom {
                color: #aabcf7;
                font-size: 82px;
                font-family: Regular;
                font-weight: 400;
                margin: -75px 79px 27px 390px;
              }
            }
          }

          .two_table_bottom_right {
            .twoTableItemWH();
            background: url("../assets/images/home_two_table_bottom_right.png");
            margin-left: 72.5px;

            .two_bottom_right_container {
              display: flex;
              flex-direction: column;

              .container_top {
                display: flex;

                .container_title {
                  margin: 37px 0 0 263px;
                  font-size: 30px;
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  color: #2A57EA;
                  line-height: 24px;
                }

                .container_english {
                  color: #aabcf7;
                  font-size: 14px;
                  font-family: Regular;
                  margin: 53px 0 0 33px;
                }
              }

              .container_center {
                color: #333333;
                font-size: 18px;
                font-family: SourceHanSansCN-Regular;
                margin: 42px 28px 0 228px;
                text-align: left;
                line-height: 36px;
              }

              .container_bottom {
                color: #aabcf7;
                font-size: 82px;
                font-family: Regular;
                margin: -30px 393px 27px 76px;
              }
            }

          }

        }

        .two_table_center {
          margin-top: -520px;
        }

      }

    }

  }

  .home_center_three {
    display: flex;
    margin-top: 74px;
    background: url("../assets/images/home_three_back.png");

    .home_center_three_container {
      width: 100%;
      display: flex;
      flex-direction: column;

      .three_about {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .three_table {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: center;

        .three_table_item {
          flex: 1;
          display: flex;
          flex-direction: column;
          background: white;
          border-radius: 10px;
          cursor: pointer;

          .three_table_item_image {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .three_table_item_text {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #2A57EA;
            margin-bottom: 12px;
            font-size: 28px;
            font-family: SourceHanSansCN-Medium;

            .three_table_item_point {
              display: flex;
              justify-content: center;
              align-content: center;
              width: 15px;
              height: 15px;
              margin: 0 32px 0 32px;
              background: url("../assets/images/home_point.png");
            }
          }
        }
      }
    }
  }

  .home_center_four {
    display: flex;
    margin-bottom: 84px;

    .home_center_four_container {
      display: flex;
      width: 100%;
      flex-direction: column;

      .four_about {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .four_table {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .four_table_item {
          display: flex;
          flex-direction: column;
          width: 295px;
          height: 500px;
          margin: 10px 15px;
          cursor: pointer;

          .four_table_item_image {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .four_table_item_text {
            color: #ffffff;
            margin-top: -64px;
            margin-bottom: 12px;
            font-size: 28px;
            font-family: SourceHanSansCN-Medium;
          }
        }
      }
    }
  }

}

</style>

